// this is an autogenerated file from DesignSystem/EditAutomation/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_EditAutomation(
  $id: uuid!
  $type: String!
  $data: jsonb!
  $actions: [automations_update_automation_actions_input!]!
) {
  automations_analyze_action_updates(
    id: $id
    type: $type
    data: $data
    actions: $actions
  ) {
    newly_scheduled
    removed
    rescheduled
    sent_immediately
    total_affected
  }
}

`